import * as React from 'react';
import { AnimatedCollapsibleContent } from './collapsible/AnimatedCollapsibleContent';
import { PageSectionHeaderBase } from './PageSectionHeader';
import { PageSectionContent } from './PageSectionContent';
import { Tabber2, TabItem2 } from './Tabber2';
import { Button } from './button/Button';
import { Flex } from './compositeComponents/FlexHelpers';



export type PageSectionTabsProps = {
    header: {
        tabberProps:{
            items: TabItem2[],
            selectedTabName?: string,
            onClick?: (tabName: string) => void
        },
        customButtonContent?: React.ReactNode,
        defaultCollapsed?:boolean
        onCollapsedChanged?:(collapsed:boolean)=>void,
    },
    contentPadding?: string;
}

export const PageSectionTabs = (props:React.PropsWithChildren<PageSectionTabsProps>): JSX.Element => {
    const [collapsed, setCollapsed] = React.useState(
        props.header?.defaultCollapsed === undefined ? false : props.header.defaultCollapsed
    );

    React.useEffect(() => {
        if(props.header?.defaultCollapsed !== undefined && props.header.defaultCollapsed !== collapsed)
            setCollapsed(props.header.defaultCollapsed);
    }, [props.header?.defaultCollapsed]);

    return (


        <div>
            <PageSectionHeaderBase
                collapsed={collapsed}
                contentStyleVariant='card'
                headerStyleVariant='card'
                padding='8px 16px 5px 16px'>
                
                <Flex alignItems='center' gap={8}>
                    {props.header.defaultCollapsed !== undefined &&
                        <Button
                            className="page-section-header-button"
                            variant='text'
                            icon={collapsed ? 'arrows_chevron_chevronDown' : 'arrows_chevron_chevronUp'}
                            onClick={() => {
                                setCollapsed(!collapsed);
                                props.header.onCollapsedChanged?.(!collapsed);
                            }} />
                    }

                    <div style={{ flex: 1 }}>
                        <Tabber2 variant="text" alignment='left' {...props.header.tabberProps} />
                    </div>
                    <div style={{ flex:0}}>
                        {props.header.customButtonContent}
                    </div>
                </Flex>

            </PageSectionHeaderBase>


            <AnimatedCollapsibleContent open={!collapsed}>
                <PageSectionContent
                    headerStyleVariant='card'
                    contentStyleVariant='card'>

                    {props.children}

                </PageSectionContent>
            </AnimatedCollapsibleContent>
        </div>
    );
};